import { render, staticRenderFns } from "./table-shen-cha.vue?vue&type=template&id=e2d57d64&scoped=true&"
import script from "./table-shen-cha.vue?vue&type=script&lang=js&"
export * from "./table-shen-cha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d57d64",
  null
  
)

export default component.exports